import { getFormattedDurationShort } from '../../../../../common/duration'
import React from 'react'
import { CrossClientQueryExecution } from '../../../../../models/CrossClient'
import { useNavigate } from 'react-router-dom'

export interface CrossClientQueryStoppedProps {
  execution: CrossClientQueryExecution
}

export const CrossClientQueryStoppedInfo: React.FC<CrossClientQueryStoppedProps> = ({ execution }) => {
  const navigate = useNavigate()

  return (
    <div className='d-flex flex-column gap-2'>
      {execution.startedAt && execution.canceledAt ? (
        <div className='paragraph-small zocks-text-gray-700'>Stopped at {getFormattedDurationShort(execution.startedAt, execution.canceledAt)}</div>
      ) : null}
      <div
        className='d-flex gap-1 align-items-center zocks-text-primary cursor-pointer'
        role='button'
        onClick={() => navigate('/cross-client', { state: { userQuestion: execution.userQuestion, decomposition: execution.decomposition } })}
      >
        <i className='bi bi-arrow-clockwise fs-5' />
        <div className='paragraph-small medium'>Run this query again</div>
      </div>
    </div>
  )
}
